<template>
  <div class="content">
    <div class="columns is-centered is-gapless" style="margin-top: 3rem;">
      <div class="column is-4">
        <div class="box">
          <h2 class="is-title is-bold has-text-centered has-text-primary">
            Forgot Password
          </h2>
          <hr></hr>
          <form>
            <p>
              Please enter your email and we’ll send you a password re-set.
            </p>
            <div class="field" style="margin-top: 1rem;">
              <label class="label">Email</label>
              <p class="control has-icon">
                <input v-model="email" class="input" type="text" placeholder="email@example.com">
                <span class="icon is-small">
                  <i class="fa fa-envelope"></i>
                </span>
              </p>
            </div>
            <p class="control has-text-centered" style="margin-top: 1rem;">
              <button type="button" class="button is-primary" v-on:click="submitForm()">
                Submit
              </button>
            </p> 
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as globalConstants from '../../globalConstants.js'
// import router from '../../router'
export default {
  data () {
    return {
      email: ''
    }
  },
  methods: {
    submitForm () {
      console.log(this.email)
      axios.post(globalConstants.apiURL + '/api/v1/forgot', {email: this.email})
      .then(response => {
        if (response.data.error) {
          this.$noty.error('User not found')
        } else if (response.data.message === 'Email Sent') {
          console.log(response.data.token)
          this.$noty.success('Password reset link has been sent to your email.')
          this.email = ''
        }
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?db0d47b0